<template>
    <nav :class="['nav__mobile', { 'nav__mobile--open' : mobNavOpen }]">
        <router-link
            :to="{ path: '/dashboard' }"
            class="nav-bar__link"
            active-class="nav-bar__link--active"
            exact-active-class="nav-bar__link--active-e"
            exact
        >
            <SVGicon-home />
            <span class="nav__label">Home</span>
        </router-link>

        <router-link
            :to="{ name: 'area.index' }"
            class="nav-bar__link"
            active-class="nav-bar__link--active"
            exact-active-class="nav-bar__link--active-e"
        >
            <SVGicon-documents />
            <span class="nav__label">Presentations</span>
        </router-link>

        <button
            type="button"
            :class="['nav-bar__link', { 'nav-bar__link--open' : mobNavOpen }]"
            @click="$emit('toggleNav')"
        >
            <SVGicon-menu class="menu-icon" />
            <span class="nav__label">Menu</span>
        </button>
    </nav>
</template>

<script>
export default {
    props: {
        mobNavOpen: {
            type: Boolean,
            default: false
        }
    }
}
</script>


